import {
  GET_VAT,
  GET_ZIP_CODE_LIST,
  MODIFY_TAX,
  MODIFY_ZIPCODE
} from '@store/officialTopupNew/index';
export default {
  data() {
    return {
      nextStateName: '',
      nextStateCode: '',
      currentZipCodeList: [],
      zipCodeListCache: {},
      curTaxRate: 0
    };
  },
  computed: {},
  methods: {
    // 邮编校验
    async zipCodeValidorFunc() {
      if (this.nextLocationVal === 'US') {
        if (this.nextZipCode?.length !== 5) {
          this.zipCodeValidor = false;
          return;
        }
        const res = await this.$store.dispatch(GET_VAT, {
          zip_code: this.nextZipCode
        });
        if (res.data?.STATE_ABBREV) {
          //zipcode存在处理
          this.zipCodeValidor = true;
          this.curTaxRate =
            res.data.TAX_FREE === 'N'
              ? (+res.data.TOTAL_SALES_TAX * 100).toFixed(4)
              : 0;
          // 处理zipcode的下拉框
          this.getZipCodeList(res.data.STATE_ABBREV);
          // zipcode反查州的值
          const usStates = this.getUsStateOptions();
          const curState = usStates.find(
            item => item.value === res.data.STATE_ABBREV
          );
          this.nextStateName = curState.label;
          this.nextStateCode = curState.value;
        } else {
          //zipcode不存在清空州
          this.zipCodeValidor = false;
          this.curTaxRate = 0;
          this.nextStateName = '';
          this.nextStateCode = '';
        }
      } else {
        this.nextZipCode = '';
        this.zipCodeValidor = true;
      }
    },
    getZipCodeList(stateCode) {
      if (this.zipCodeListCache[stateCode]) {
        // 缓存中存在
        this.currentZipCodeList = this.zipCodeListCache[stateCode];
      } else {
        // 没缓存请求接口
        this.$store
          .dispatch(GET_ZIP_CODE_LIST, { state: stateCode })
          .then(res => {
            this.currentZipCodeList = res.data.map(item => ({
              label: item.ZIP_CODE,
              value: item.ZIP_CODE
            }));
            this.zipCodeListCache[stateCode] = this.currentZipCodeList;
          });
      }
    },
    // 获取税费
    async getCurrentTax(info) {
      const res = await this.$store.dispatch(GET_VAT, {
        zip_code: info.zipCode,
        amount: info.amount,
        currency: info.currency
      });
      this.$store.commit(MODIFY_TAX, res.data?.TAX_AMOUNT);
    },
    // 判断已有zipcode是否合规
    async isZipCodeValidFunc(zipCode) {
      if (!zipCode) return false;
      const res = await this.$store.dispatch(GET_VAT, {
        zip_code: zipCode
      });
      if (res.data?.STATE_ABBREV) {
        return true;
      } else {
        this.$store.commit(MODIFY_ZIPCODE, '');
        return false;
      }
    }
  }
};
